module.exports = __webpack_public_path__ + "media/images/guide/image2-6456c56347a60ee804077ce17eb2f5fa.png";